import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RouteSectionView.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import { TiEntities, TiInterfaces } from "../TiTypes";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import { ToasterHelpers } from "../../../more/Helpers";

class TiRouteSectionsView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private slotInfoContainer: HTMLElement;
    private topContainer: HTMLElement;
    private iconNode: HTMLElement;
    private statusIconContainer: HTMLElement;
    private titleNode: HTMLElement;
    private descriptionNode: HTMLElement;

    private sectionBookingStatus: HTMLElement;
    private statusInputContainer: HTMLElement;
    private sectionExtendedInfo: HTMLElement;
    private statusContainer: HTMLElement;
    private bookedInfoContainer: HTMLElement;
    private txtBookedOn: HTMLElement;
    private txtBookedBy: HTMLElement;
    private txtDateStart: HTMLElement;
    private txtDateEnd: HTMLElement;
    private txtBufferTime: HTMLElement;
    private txtPickupDate: HTMLElement;
    private txtStatus: HTMLElement;

    private sectionSlot: TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension;
    private availableStatus: Array<TiEntities.TimeSlotBookingStatus>;

    private inputStatus: MdsLax<InstanceType<typeof SelectBox>>;

    private externalBookingButton: HTMLButtonElement;
    private txtBookingStatusEx: HTMLParagraphElement;
    private txtBookingNumberEx: HTMLParagraphElement;
    private txtBookingStatusExContainer: HTMLDivElement;
    private txtBookingNumberExContainer: HTMLDivElement;

    private externalBookingTargetProvider: "txlogistik" | "stenaline" | "ttline";

    private config: TiInterfaces.TiRouteSectionsViewConfg = {
        highlight: false,
        enableBookingStatus: false
    };

    setData(sectionSlotEntity: TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension,
        config?: TiInterfaces.TiRouteSectionsViewConfg) {


        if (config && sectionSlotEntity._isDummy) {
            //config.showExtendedInformation = false;
            config.enableBookingStatus = false;
        }

        if (config) this.setConfig(config);

        this.sectionSlot = sectionSlotEntity;

        this.drawData();        
    }

    setConfig(config: TiInterfaces.TiRouteSectionsViewConfg) {
        this.config = config;

        if (config.enableBookingStatus) {
            this.hideNode(this.sectionBookingStatus, false);
            // eine kleine random Verzögerung machen, damit bei mehreren gleichzeitig startenden Widgets eines zuerst lädt und die anderen warten:
            if (config.enableBookingStatus == "interactive") {
                setTimeout(lang.hitch(this, this.loadAvailableBookingStatus), Math.random() * 100);
            }
        }

        if (this.sectionSlot) {
            this.drawData();
        }
    }

    private _onClick_CreateExternalBooking() {
        let dlg = new GenericDialog();

        dlg.show(
            this.translate("Ti_RouteSectionView_Confirm_CreateExternalBooking"),
            this.sectionSlot.sectionName,
            this.sectionSlot.sectionSlotAssignmentName,
            "fas fa-question-triangle",
            "yesno",
            lang.hitch(this, this._onConfirmCreateExternalBooking)
        );
    }

    
    private _onConfirmCreateExternalBooking(result: number) {
        if (result >= 2) // ja
        {
            this.StandbyStart();

            let jsonData = {
                "type": this.externalBookingTargetProvider,
                "slotID": this.sectionSlot.ID
            };
            this.RequestManager.callfunction("Webtool_API_TransportIntermodal__CreateExternalBooking", jsonData, lang.hitch(this, this._onCreateExternalBooking_Response), lang.hitch(this, this._onCreateExternalBooking_Error));
        }
    }

    private _onCreateExternalBooking_Response(modifiedSlotItem: TiEntities.SectionTimeSlotEntity_Aliased) {
        this.StandbyStop();

        this.showToast({
            title: this.translate("Ti_ExternalBookingCreated"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        this.sectionSlot = modifiedSlotItem;

        this.drawData();
        this.drawStatusInputs();

        this.emit("change");
    }

    private _onCreateExternalBooking_Error(error) {
        this.StandbyStop();
        this.showToast({
            title: this.translate("General_ErrorMessageSave"),
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: JSON.stringify( error ),
            //message: error,
            timeout: "permanent",
        });
    }

    private _onRouteSectionsStatusAvailable(id: string) {
        //console.debug(this.id + " _onRouteSectionsStatusAvailable");
        this.removeSubscription("routeSectionsStatus/Loaded");

        setTimeout(lang.hitch(this, this.loadAvailableBookingStatus), 50);
    }

    private loadAvailableBookingStatus() {
        let cachedDataStr = localStorage.getItem("routeSectionsStatus");
        let cachedData = null;


        if (cachedDataStr === "loading") {
            // falls ein anderes Widget schon lädt: warten
            this.addSubscription("routeSectionsStatus/Loaded", lang.hitch(this, this._onRouteSectionsStatusAvailable));
            return;
        }

        if (cachedDataStr) {
            try {
                cachedData = JSON.parse(cachedDataStr);
            } catch (ex) {

            }
        }

        if (cachedData == null) {
            cachedDataStr = "loading";
            localStorage.setItem("Ti_routeSectionsStatus", cachedDataStr);

            this.RequestManager.callfunction(
                "Webtool_API_TiRouteSlotsReview__GetTimeslotBookingStatusList",
                {},
                lang.hitch(this, this._onLoadAvailableBookingStatusResult),
                lang.hitch(this, this._onLoadAvailableBookingStatusError)
            )
        } else {
            this._onLoadAvailableBookingStatusResult(cachedData);
        }

    }

    private _onLoadAvailableBookingStatusError(error: more.requestErrorMessage) {
        localStorage.removeItem("Ti_routeSectionsStatus");
    }

    private _onLoadAvailableBookingStatusResult(result: Array<TiEntities.TimeSlotBookingStatus>) {
        this.removeSubscription("routeSectionsStatus/Loaded");
        localStorage.setItem("Ti_routeSectionsStatus", JSON.stringify(result));
        setTimeout(lang.hitch(this, function () { topic.publish("routeSectionsStatus/Loaded") }), 100);

        this.availableStatus = result;

        this.drawStatusInputs();
    }

    private drawStatusInputs() {
        this.hideNode(this.statusInputContainer, false);
        this.UiModder.domConstruct.empty(this.statusInputContainer);
        this.disableNode(this.sectionBookingStatus, this.sectionSlot.is_cancelled == true);

        let input = new SelectBox();
        input.placeAt(this.statusInputContainer, "only");
        //input.labelAttribute = "name";
        input.setLabel(this.translate("General_Label_ChangeStatus"))
        input.startup();
        //input.setData(this.availableStatus);
        input.setData(this.sectionSlot.bookingStatusID, this.availableStatus, "ID", "name", true, "coloration", "coloration");
        //input.setValue(this.sectionSlot.bookingStatusID, true);

        input.on("change", lang.hitch(this, this._onChange_Status))

        this.inputStatus = input;
    }

    private _onChange_Status(statusID: string) {
        statusID = this.inputStatus.getValue();
        this.saveStatus(statusID);
        this.disableNode(this.sectionBookingStatus);
    }

    private saveStatus(statusID: string) {
        let data = {
            "sectionTimeslotID": this.sectionSlot.ID,
            "statusID": statusID
        };

        this.RequestManager.callfunction(
            "Webtool_API_TiRouteSlotsReview__SaveTimeslotBookingStatus",
            data,
            lang.hitch(this, this._onSaveStatusResponse),
            lang.hitch(this, this._onSaveStatusError),
            true
        )
    }

    private _onSaveStatusError(error: more.requestErrorMessage) {
        alert(error.Message);
        this.drawStatusInputs();
    }

    private _onSaveStatusResponse(updatedSetion: TiEntities.SectionTimeSlotEntity_Aliased) {
        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        this.sectionSlot = updatedSetion;

        this.drawData();

        this.emit("change");
    }

    private drawData() {

        let sectionSlot = this.sectionSlot;
        let container = this.domNode;

        this.UiModder.domClass.toggle(this.domNode, "cancelled", sectionSlot.is_cancelled);

        if (this.config.enableBookingStatus) {
            this.disableNode(this.sectionBookingStatus, sectionSlot.is_cancelled == true);

            this.sectionBookingStatus.style.setProperty("--bgColor", sectionSlot.bookingStatusColor?.BackColor.Hex);
            this.sectionBookingStatus.style.setProperty("--txtColor", sectionSlot.bookingStatusColor?.TextColor.Hex);

            if (sectionSlot.bookingStatusChangeAddress) {
                this.txtBookedBy.innerHTML = sectionSlot.bookingStatusChangeAddress;
                this.hideNode(this.bookedInfoContainer, false);
            }

            if (sectionSlot.bookingStatusChangeDate) {
                this.txtBookedOn.innerHTML = this.dateToString(sectionSlot.bookingStatusChangeDate, "dd.MM.yyyy HH:mm");
                this.hideNode(this.bookedInfoContainer, false);
            }

        }

        this.hideNode(this.descriptionNode, this.config?.showExtendedInformation === true);

        this.hideNode(this.sectionExtendedInfo, !this.config?.showExtendedInformation);

        this.disableNode(this.sectionExtendedInfo, sectionSlot.is_cancelled == true);

        let dummyFilltext = this.createFontawesomeIcon("fas fa-question").outerHTML;

        if (!sectionSlot._isDummy) {
            this.txtStatus.innerHTML = sectionSlot.statusName;
            this.UiModder.domClass.toggle(this.txtStatus, "warningTXT", sectionSlot.is_cancelled == true);
            this.txtDateStart.innerHTML = this.dateToString(sectionSlot.date_start, "EEE dd.MM.yyyy HH:mm");
            this.txtDateEnd.innerHTML = this.dateToString(sectionSlot.date_end, "EEE dd.MM.yyyy HH:mm");
            this.txtBufferTime.innerHTML = sectionSlot.buffer_time ? sectionSlot.buffer_time.toString() : "-";
            this.txtPickupDate.innerHTML = sectionSlot.pickup_date ? this.dateToString(sectionSlot.pickup_date, "EEE dd.MM.yyyy HH:mm") : "-";
        } else {
            this.UiModder.domAttr.setMultiple([this.txtStatus,
                this.txtDateStart,
                this.txtDateEnd,
                this.txtBufferTime,
                this.txtPickupDate],
                "innerHTML",
                dummyFilltext);

            this.UiModder.domClass.add(this.domNode, "dummy");

        }


        this.hideNode(this.statusContainer, this.config.enableBookingStatus !== true);
        this.UiModder.domAttr.set(this.statusContainer, "innerHTML", sectionSlot.bookingStatusName);
        this.UiModder.domStyle.set(this.statusContainer, "backgroundColor", sectionSlot.bookingStatusColor?.BackColor.Hex);
        this.UiModder.domStyle.set(this.statusContainer, "color", sectionSlot.bookingStatusColor?.TextColor.Hex);

        this.UiModder.domClass.add(container, sectionSlot.Classname);

        let topRow = this.topContainer;
        this.UiModder.domConstruct.empty(this.titleNode);
        this.UiModder.domAttr.set(this.titleNode, "innerHTML", sectionSlot.sectionName ? sectionSlot.sectionName : dummyFilltext);
        this.UiModder.domAttr.set(this.descriptionNode, "innerHTML", sectionSlot.name ? sectionSlot.name : dummyFilltext);

        if (sectionSlot.transportTypeIcon) {
            let icon = this.createFontawesomeIcon(sectionSlot.transportTypeIcon);
            this.UiModder.domConstruct.place(icon, this.iconNode, "only");
            this.UiModder.domClass.add(icon, "paddingY paddingSmallRight");
        } else if (sectionSlot._isDummy) {
            let icon = this.createFontawesomeIcon("fas fa-question-circle");
            this.UiModder.domConstruct.place(icon, this.iconNode, "only");
            this.UiModder.domClass.add(icon, "paddingY paddingSmallRight");
            this.hideNode(this.descriptionNode);

            if (sectionSlot._placeholderLabel) {
                this.UiModder.domAttr.set(this.titleNode, "innerHTML", sectionSlot._placeholderLabel);
            }            

        }

        let highlightSectionID = this.config?.highlight === true;

        this.UiModder.domClass.toggle(this.domNode, "highlight", highlightSectionID);

        this.UiModder.domClass.toggle(this.domNode, "cancelled", sectionSlot.is_cancelled === true);
        if (sectionSlot.is_cancelled === true) {
            this.createFontawesomeIcon("fa-solid fa-ban", "", this.statusIconContainer);
        }

        this.hideNode(this.txtBookingNumberExContainer, sectionSlot.bookingStatus == null || sectionSlot.bookingStatus == "" );
        this.hideNode(this.txtBookingStatusExContainer, sectionSlot.bookingStatus == null || sectionSlot.bookingStatus == "" );
        this.disableNode(this.externalBookingButton, sectionSlot.bookingStatus != null && sectionSlot.bookingStatus != "");

        this.txtBookingStatusEx.innerText = sectionSlot.bookingStatus;
        this.txtBookingNumberEx.innerText = sectionSlot.bookingNumber;

        if (sectionSlot.transportTypeName == "Zug") {
            this.externalBookingButton.innerText = "Buchen (Tx)";
            this.externalBookingTargetProvider = "txlogistik";
            this.hideNode(this.externalBookingButton, !this.hasUserRole("TI_TxLogistikBooking"));
        } else {
            this.hideNode(this.externalBookingButton);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }

    destroy(): void {
        localStorage.removeItem("Ti_routeSectionsStatus");
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiRouteSectionsView);